import React, { useEffect, useState, useContext, useRef, Children } from 'react';
import { Button, Form, Input, ProTableOt, Row, Col, Select, Typography, DatePicker, message, Modal, InputNumber, MainModal, Accordion, AccordionItem, AccordionTrigger, AccordionContent, UploadDocument, UploadAudio, UploadImg, UploadVidio, TreeSelect, Tabs, Switch, TimePicker, Textarea } from "../../../ui/ot";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faFileAlt, faUpload } from '@fortawesome/free-solid-svg-icons';
const ImportButton = ({
    handleImport,
    handleDownload,
    set_upload_modal,
    upload_modal,
    importData,
    setImportData,
    columns,
    import_modal,
    set_import_modal,
    handleOver,
    handleReserve
}) => {
    const [data, setData] = useState([]);
    const ref = useRef(0);
    const handleImportModal = (e) => {
        set_upload_modal(true);
    }
    useEffect(() => {
        if (importData?.length != 0) {
            console.log(importData);
            set_import_modal(true);
            setData(importData);
        }
    }, [importData])
    const handlePreOver = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'name')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleOver(data_tmp);
        }
    }
    const handlePreReserve = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'both')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleReserve(data_tmp);
        }
    }
    return (
        <>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={upload_modal}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ padding: '30px', position: 'relative', minHeight: '25vh' }}>
                        <Row gutter={[10, 10]} justify='center' >
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button style={{ background: '#616161', color: '#ffffff' }} onClick={(e) => handleDownload()} block>
                                            範例檔案下載
                                            <FontAwesomeIcon icon={faFileAlt} style={{ marginLeft: '2px' }}/>
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: '#FF9800', color: '#FFFFFF' }} onClick={(e) => ref.current.click()} block>
                                            檔案上傳
                                            <FontAwesomeIcon icon={faUpload} style={{ marginLeft: '2px' }}/>
                                        </Button>
                                        <input type="file" id="my_file" hidden ref={ref} onChange={(e) => handleImport(e)} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => { set_upload_modal(false); }} block>取消</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal>
            <Modal
                style={{ pointerEvents: 'auto' }}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                open={import_modal}
                width={1000}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ padding: '30px', position: 'relative', minHeight: '25vh' }}>
                        <Row gutter={[10, 10]} justify={'center'}>
                            <Col span={24}>
                                <Row gutter={[16, 10]}>
                                    <Col>
                                        <Button type='primary' onClick={handlePreReserve}>全部保留</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: 'rgba(232, 79, 117, 1)', color: '#FFFFFF' }} onClick={handlePreOver}>全部覆蓋</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>全部取消</Button>
                                    </Col>
                                    <Col span={24}>
                                        <ProTableOt
                                            tableLayout={'fixed'}
                                            scroll={{ x: 'max-content' }}
                                            columns={columns}
                                            dataSource={data}
                                            pagination={false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>關閉</Button>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal>
            <Button type='file' className='example' style={{ backgroundColor: '#388E3C', color: '#FFFFFF' }} onClick={(e) => handleImportModal()}>
                匯入資料
                <FontAwesomeIcon icon={faFileImport} style={{ marginLeft: '2px' }}/>
            </Button>

        </>
    )

}
export default ImportButton;